import { makeStyles } from '@mui/styles';

const useReportsStyle = makeStyles(() => ({
  container: {
    width: '100%',
  },
}));

export default useReportsStyle;
